import axios from "axios";
import { Base_URL } from "../url";

export const saveDepartmentDetails = async (departmentData) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const userId = userDetails?.userId; 
    const response = await axios.post(
      `${Base_URL}/DepartmentMaster/CreateDepartment?UserName=${userId}`,
      departmentData
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving department details!";
  }
};

export const getOfficeData = async () => {
  try {
    const response = await axios.get(`${Base_URL}/Office/OfficeGetData`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching office data!";
  }
};